// React dependencies
import React, { Component } from 'react';

// External dependencies
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { Paper, Chip, Tooltip, CircularProgress } from '@material-ui/core';

// Internal dependencies
import PostAction from '../../../../actions/post';
import ApiService from '../../../../services/apiService';
import Colours from '../../../../styles/colours';
import postStyle from '../../../../styles/post';
import Icons from '../../../../components/Common/Icons';
import { PageType } from '../../../../common/constants';
import { IsEmpty, IsNull } from '../../../../common/checks';
import MText from '../../../../components/Common/MText';

const checkStyleOn = {
  position:     'absolute',
  right:        5,
  top:          5,
  background:   '#FFF',
  color:        Colours.Primary,
  borderRadius: '100%',
  // boxShadow:    '0px 0px 1px 1px rgb(222, 0, 111)',
};

const checkStyleOff = {
  position:     'absolute',
  right:        5,
  top:          5,
  background:   'rgb(255 255 255 / 0.70)',
  color:        Colours.Gray3,
  borderRadius: '100%',
  borderColor:  Colours.Black,
};

class PromoCreditCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promoCreditCards:      [],
      selectedItems:         [...(props.post.promoCreditCards || [])],
      groupCreditCards:      [],
      totalCreditCards:      [],
      groupChildCardDisplay: [],
      chipSelectedIndex:     0,
      isFetching:            true,
    };
  }

  componentDidMount() {
    this.fetchCreditCards();
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.post?.id !== this.props.post?.id) {
      this.setState({
        selectedItems: [...(this.props.post.promoCreditCards || [])],
      });
    }

    if (
      prevProps?.page?.id !== this.props.page?.id
      || prevProps?.page?.type !== this.props.page?.type
      || prevProps?.page?.parentId !== this.props.page?.parentId
    ) {
      this.fetchCreditCards();
    }
  }

  async fetchCreditCards() {
    const { page } = this.props;

    if (IsEmpty(page.id) || IsEmpty(page.type) || typeof page.parentId === 'undefined') {
      return;
    }

    try {
      this.setState({ isFetching: true });
      if (
        IsNull(page.parentId)
        && page.type !== PageType.CreditCard
      ) {
        // IS PARENT/NON-PARENT && NON-CC PAGE TYPE
        const fetchAllCreditCards = async (id) => {
          const parentCreditCards = await ApiService.getParentCreditCards(id);

          if (parentCreditCards.length > 0) {
            const groupedCards = [];
            const cardTotals = [];

            for (const creditCard of parentCreditCards) {
              const key = creditCard.name;
              const data = creditCard.subsidiaries;
              const findObj = _.some(groupedCards, { [key]: data });
              if (!findObj) {
                groupedCards.push({ [key]: data });
                cardTotals.push(data.length);
              }
            }

            const firstGroup = groupedCards[0];

            this.setState({
              groupCreditCards:      groupedCards,
              totalCreditCards:      cardTotals,
              groupChildCardDisplay: !IsEmpty(firstGroup) ? firstGroup[_.keys(firstGroup)[0]] : [],
            });
          }
        };

        await fetchAllCreditCards(page.id);
      } else {
        // IS PARENT && CC PAGE TYPE
        const fetchCreditCards = async (id) => {
          const allCreditCardsPagesByCCParent = await ApiService.getCreditCardPagesUnderPage(id); //this.props.getCreditCardPagesUnderPage(id);
          const data = _.map(allCreditCardsPagesByCCParent, _.partialRight(_.pick, ['id', 'name', 'logo']));

          // set credit cards data.
          this.setState({
            promoCreditCards:      data,
            groupCreditCards:      [],
            totalCreditCards:      [],
            groupChildCardDisplay: [],
          });
        };
        await fetchCreditCards(page.id);
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      this.setState({ isFetching: false });
    }
  }

  onCreditCardChanged = (data) => {
    this.props.dispatchPostUpdate({ promoCreditCards: data });
  }

  handleSelected = (data) => {
    this.setState((state) => {
      const isDataAlrSelected = _.some(state.selectedItems, { id: data.id, name: data.name });
      const selectedItems = isDataAlrSelected
        ? state.selectedItems.filter((item) => item.id !== data.id)
        : [...state.selectedItems, data];

      return { selectedItems };
    }, () => this.onCreditCardChanged(this.state.selectedItems));
  }

  render() {
    const {
      groupCreditCards,
      promoCreditCards,
      selectedItems,
      totalCreditCards,
      isFetching,
    } = this.state;
    const statePromoCreditCards = groupCreditCards.length > 0 ? groupCreditCards : promoCreditCards;

    if (isFetching) {
      return (
        <div className="d-flex flex-row justify-content-center">
          <CircularProgress className="my-2 mx-2" />
        </div>
      );
    }

    return (
      <>
        <MText className="ml-3 mb-3" style={{ color: Colours.Gray }} textSize={12}>
          {`Selected ( ${selectedItems.length} / ${groupCreditCards.length > 0 ? _.sum(totalCreditCards) : promoCreditCards.length} )`}
        </MText>

        {groupCreditCards.length > 0
          ? (
            <div>
              <Paper variant="elevation" style={postStyle.paper}>
                {
                  groupCreditCards.map((cc, index) => {
                    const parentCardName = _.keys(cc)[0];
                    const count = cc[parentCardName]
                      .filter((card) => _.some(selectedItems, { id: card.id }))
                      .length;

                    return (
                      <Chip
                        key={index}
                        label={`${parentCardName} ${count > 0 ? `(${count})` : ''}`}
                        onClick={() => {
                          this.setState({
                            chipSelectedIndex:     index,
                            groupChildCardDisplay: cc[parentCardName],
                          });
                        }}
                        className="mr-3 mb-1"
                        style={{ borderColor: count > 0 ? Colours.Primary : Colours.White, borderWidth: '2px' }}
                        variant={
                          (this.state.chipSelectedIndex === index) ? 'default' : 'outlined'
                        }
                        color={this.state.chipSelectedIndex === index ? 'primary' : 'default'}
                      />
                    );
                  })
                }

                <hr />

                <div className="container">
                  <div className="row" style={{ width: '100%' }}>
                    {
                      this.state.groupChildCardDisplay.map((card) => (
                        <>
                          <Tooltip title={this.props.disabled ? this.props.disabledMsg : card.name} key={card.id}>
                            <div
                              aria-hidden="true"
                              onClick={() => (this.props.disabled ? null : this.handleSelected(card))}
                              style={{ position: 'relative' }}
                              className="col-sm-6 col-md-4 col-lg-3 mb-5 pr-3"
                            >
                              <div
                                style={{
                                  position:     'relative',
                                  background:   Colours.LightGray6,
                                  width:        100,
                                  height:       75,
                                  borderRadius: 5,
                                  cursor:       'pointer',
                                }}
                              >
                                {
                                  !IsEmpty(card.logo) && (
                                    <img
                                      src={card.logo}
                                      style={{ borderRadius: 5, cursor: 'pointer', width: 100, height: 75 }}
                                      alt="img"
                                    />
                                  )
                                }
                                {
                                  _.some(selectedItems, { id: card.id })
                                    ? <Icons.Checked style={checkStyleOn} />
                                    : <Icons.UnChecked style={checkStyleOff} />
                                }
                              </div>
                              <MText
                                variant="caption"
                                colour={Colours.Gray}
                                size={10}
                                style={{ marginTop: 10 }}
                                text={card.name}
                              />
                            </div>
                          </Tooltip>
                        </>
                      ))
                    }
                  </div>
                </div>
              </Paper>
            </div>
          )

          : (
            <div>
              {statePromoCreditCards.length > 0
                ? (
                  <div className="row" style={{ width: '100%' }}>
                    {statePromoCreditCards.map((card, index) => (
                      <>
                        <Tooltip title={this.props.disabled ? this.props.disabledMsg : card.name} key={index}>
                          <div aria-hidden="true" onClick={() => this.handleSelected(card)} className="col-md-2 mb-5">
                            <div style={{
                              position:     'relative',
                              background:   Colours.LightGray6,
                              width:        85,
                              height:       85,
                              borderRadius: 5,
                              cursor:       'pointer',
                            }}
                            >
                              {
                                !IsEmpty(card.logo) && (
                                  <img
                                    src={card.logo}
                                    alt={card.name}
                                    style={{ borderRadius: 5, cursor: 'pointer', width: 85, height: 'auto' }}
                                  />
                                )
                              }
                              {
                                _.some(selectedItems, { id: card.id, name: card.name })
                                  ? <Icons.Checked style={checkStyleOn} />
                                  : <Icons.UnChecked style={checkStyleOff} />
                              }
                            </div>
                            <MText
                              variant="caption"
                              colour={Colours.Gray}
                              size={10}
                              style={{ marginTop: 10 }}
                              text={card.name}
                            />
                          </div>
                        </Tooltip>
                      </>
                    ))}
                  </div>
                ) : 'There are no subsidiaries under this brand.'}
            </div>
          )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  post: state.post.selected,
  page: state.page.selected,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchPostUpdate: (post) => PostAction.postDataUpdate(dispatch, post),
});

PromoCreditCard.defaultProps = {
  disabledMsg: '',
};

PromoCreditCard.propTypes = {
  dispatchPostUpdate: PropTypes.func.isRequired,
  post:               PropTypes.shape(Object).isRequired,
  page:               PropTypes.shape(Object).isRequired,
  disabled:           PropTypes.bool.isRequired,
  disabledMsg:        PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(PromoCreditCard);
